// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"697c191d","255":"c9188d31","348":"5629b4b7","352":"ec3280b9","673":"3825d095","817":"2636b485"}[chunkId] + ".chunk.js";
};